import { requestPersistentStorage } from '@/lib/platform.js';
import '@a-type/ui/main.css';
import '@biscuits/client/global.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { attachToPwaEvents } from './pwaEventListener.js';

function main() {
	const root = createRoot(document.getElementById('root')!);
	root.render(
		<StrictMode>
			<App />
		</StrictMode>,
	);
}

main();

attachToPwaEvents();
requestPersistentStorage();

function debugUno() {
	setTimeout(
		() =>
			navigator.clipboard.writeText(
				document.querySelector('[data-vite-dev-id="/__uno.css"]')
					?.textContent ?? 'failed to copy',
			),
		3000,
	);
}
(window as any).debugUno = debugUno;
